import React from 'react';
import { Button, LoadingButton, ModalHeader, ModalBody, ModalFooter, Typography, } from '@one-thd/sui-atomic-components';
import { getHyphenatedPhoneNumber } from '../../../utils/general';
export const ResendInviteModal = ({ hideModal, onResendInvite, isLoading, t2cNumber, }) => {
    return (React.createElement(React.Fragment, null,
        React.createElement(ModalHeader, { onClose: hideModal }, "Resend Text2Confirm Invite"),
        React.createElement(ModalBody, null,
            React.createElement(Typography, { variant: "body-base" }, "A text message will be sent to the number below. The user must reply to the text message to confirm Text2Confirm enrollment."),
            React.createElement("div", { className: "sui-mt-4" },
                React.createElement(Typography, { variant: "body-base", weight: "bold", "data-qm-mask": "" }, getHyphenatedPhoneNumber(t2cNumber)))),
        React.createElement(ModalFooter, { position: "end" },
            React.createElement("div", { className: "sui-flex sui-gap-4 sm:sui-gap-4 sui-flex-col-reverse sui-w-full sm:sui-flex-row sm:sui-w-auto" },
                React.createElement(Button, { variant: "secondary", onClick: hideModal }, "Cancel"),
                React.createElement(LoadingButton, { loading: isLoading, variant: "primary", onClick: onResendInvite }, "Resend Invite")))));
};
ResendInviteModal.displayName = 'ResendInviteModal';
